import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ListsComponent } from '../../lists.shared.component';

@Component({
    selector: 'shared-list-for-promotion-items',
    templateUrl: './list-for-promotion-items.shared.component.html',
    styleUrls: ['./list-for-promotion-items.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForPromotionItemsComponent extends ListsComponent {
    @Input() public promotionItems: APICommon.IPromotionItem[];
    @Input() public layout: 'row' | 'column' = 'row';

    constructor() {
        super();

        this.placeholders = window?.innerWidth > 767 ? 3 : 1;
    }

    public trackBy(index: number, item: APICommon.IPromotionItem): number {
        return item?.Id || index;
    }
}
